module.exports = __webpack_public_path__ + "static/media/gpv-bulk-billed-medical-centre.b6d67a99.png";